import React from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

const newsInStyle = `
@keyframes newsIn {
  from { opacity: 0; transform: translateY(28px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0)     scale(1);    }
}
@keyframes livePulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.4; transform: scale(1.25); }
}
@media (min-width: 1280px) {
  .show-video-card { max-width: 450px !important; }
}
`;

export const VideoModal = ({ video, onClose, tagLabel = "Actualité · à l'instant", showMarketsCta = true }) => {
    const navigate = useNavigate();

    if (!video) return null;

    return createPortal(
        <>
            <style>{newsInStyle}</style>
            {/* Backdrop */}
            <div
                onClick={onClose}
                style={{
                    position: 'fixed', inset: 0, zIndex: 9999,
                    overflowY: 'auto',
                    background: 'rgba(5,7,18,0.62)',
                    backdropFilter: 'blur(7px)',
                    WebkitBackdropFilter: 'blur(7px)',
                }}
            >
                {/* Wrapper de centrage — minHeight:100% permet le scroll si la carte dépasse le viewport */}
                <div style={{
                    minHeight: '100%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: '18px',
                }}>
                {/* Card */}
                <div
                    onClick={(e) => e.stopPropagation()}
                    className="show-video-card"
                    style={{
                        width: '100%', maxWidth: 360, maxHeight: '90vh',
                        display: 'flex', flexDirection: 'column',
                        borderRadius: 28,
                        background: 'linear-gradient(180deg, rgba(24,39,68,0.38) 0%, #0E1830 38%), #14213D',
                        border: '1px solid rgba(255,255,255,0.07)',
                        boxShadow: '0 30px 70px -22px rgba(0,0,0,0.75), inset 0 1px 0 rgba(255,255,255,0.07)',
                        padding: 18,
                        position: 'relative',
                        animation: 'newsIn .36s cubic-bezier(0.16, 1, 0.3, 1)',
                    }}
                >
                    {/* Ligne du haut : tag + fermer */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        {
                            tagLabel && (
                                <div style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 7,
                                    padding: '5px 10px 5px 9px', borderRadius: 999,
                                    background: 'rgba(255,255,255,0.06)',
                                    border: '1px solid rgba(255,255,255,0.07)',
                                }}>
                                    <span style={{
                                        width: 6, height: 6, borderRadius: '50%', background: '#ef4444',
                                        animation: 'livePulse 1.6s ease-in-out infinite',
                                        flexShrink: 0,
                                    }}/>
                                    <span style={{
                                        fontSize: 10.5, fontWeight: 700, letterSpacing: '0.12em',
                                        textTransform: 'uppercase', color: '#97A4BE',
                                    }}>{tagLabel}</span>
                                </div>
                            )
                        }
                        <button
                            onClick={onClose}
                            aria-label="Fermer"
                            style={{
                                width: 32, height: 32, borderRadius: 16,
                                background: 'rgba(255,255,255,0.06)',
                                border: '1px solid rgba(255,255,255,0.07)',
                                color: '#97A4BE', cursor: 'pointer',
                                display: 'grid', placeItems: 'center', padding: 0, flexShrink: 0,
                                marginLeft: tagLabel ? 0 : 'auto',
                            }}
                        >
                            <svg width="12" height="12" viewBox="0 0 12 12">
                                <path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                            </svg>
                        </button>
                    </div>

                    {/* Titre */}
                    <h2 style={{
                        margin: '14px 2px 0',
                        fontSize: 21, fontWeight: 700, lineHeight: 1.25,
                        letterSpacing: '-0.015em', color: '#F2F5FB',
                        textWrap: 'balance',
                    }}>
                        {video.title}
                    </h2>

                    {/* Cadre vidéo portrait */}
                    <div style={{
                        marginTop: 16, flex: 1, minHeight: 0,
                        position: 'relative', width: '100%',
                        aspectRatio: '3 / 4',
                        borderRadius: 18, overflow: 'hidden',
                        background:
                            'radial-gradient(120% 90% at 50% -10%, rgba(122,184,224,0.14), transparent 55%),' +
                            'linear-gradient(180deg, #1a2740 0%, #0c1426 100%)',
                        border: '1px solid rgba(255,255,255,0.10)',
                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06), inset 0 0 60px rgba(0,0,0,0.45)',
                    }}>
                        <video
                            key={video.video_path}
                            controls
                            autoPlay
                            playsInline
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        >
                            <source src={'/storage/' + video.video_path} type="video/mp4" />
                        </video>

                        {/* Logo watermark */}
                        <div style={{ position: 'absolute', top: 12, left: 12, opacity: 0.92, pointerEvents: 'none' }}>
                            <img
                                src="/logo-application-trading.png"
                                alt=""
                                style={{ height: 18, width: 'auto', display: 'block', filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.6))' }}
                            />
                        </div>

                        {/* Vignette cinématique */}
                        <div style={{
                            position: 'absolute', inset: 0, pointerEvents: 'none',
                            background: 'linear-gradient(180deg, rgba(0,0,0,0.28) 0%, transparent 22%, transparent 78%, rgba(0,0,0,0.3) 100%)',
                        }}/>
                    </div>

                    {/* CTA Voir les marchés */}
                    {showMarketsCta && (
                        <button
                            onClick={() => { onClose(); navigate('/portefeuille_menu'); }}
                            style={{
                                marginTop: 16, height: 54, borderRadius: 16, width: '100%',
                                background: 'linear-gradient(180deg, #ffffff 0%, #e3e8f1 100%)',
                                color: '#0A1226', border: 'none', cursor: 'pointer',
                                fontWeight: 700, fontSize: 15,
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9,
                                boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 10px 24px -10px rgba(0,0,0,0.6)',
                                flexShrink: 0,
                            }}
                        >
                            Voir les marchés
                            <svg width="15" height="15" viewBox="0 0 15 15">
                                <path d="M3 7.5h8M8 4l3.5 3.5L8 11" stroke="#0A1226" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    )}
                </div>
                </div>
            </div>
        </>,
        document.body
    );
};
